import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';

import { Link } from 'react-router-dom';

import ProfileModal from '../../components/Modal/ProfileModal';
import DialogChatModal from '../../components/Modal/DialogChatModal';
import BroadCastModal from '../../components/Modal/BroadCastModal';
import Select from 'react-tailwindcss-select';
import Swal from 'sweetalert2';

import Green from '../../components/Form/PCheckSvg/Green';
import Orange from '../../components/Form/PCheckSvg/Orange';
import Red from '../../components/Form/PCheckSvg/Red';
import GreenPay from '../../components/Form/PayCheckSvg/GreenPay';
import RedPay from '../../components/Form/PayCheckSvg/RedPay';
import { useDispatch, useSelector } from 'react-redux';
import { getVacancySingle } from '../../redux/actions/dashborad/getVacancySingle';
import { getVacancyHistory } from '../../redux/actions/dashborad/getVacancyHistory';
import Input from '../../components/Input/Input';
import { useForm } from 'react-hook-form';
import { skipVerification } from '../../redux/actions/dashborad/skipVerification';
import { resetApproveModerationVacancy, resetRemoveModerationVacancy, resetRemoveSentModerationVacancy, resetSentModerationVacancy, resetSkipVerification, resetUpdateModerationVacancy } from '../../redux/slices/dashboard.slice';
import Loading from '../../components/Loading/Loading';
import { updateModerationVacancy } from '../../redux/actions/dashborad/updateModerationVacancy';
import { getModerationVacancy } from '../../redux/actions/dashborad/getModerationVacancy';
import { sentModerationVacancy } from '../../redux/actions/dashborad/sentModerationVacancy';
import { approveModerationVacancy } from '../../redux/actions/dashborad/approveModerationVacancy';
import { removeModerationVacancy } from '../../redux/actions/dashborad/removeModerationVacancy';
import { removeSentModerationVacancy } from '../../redux/actions/dashborad/removeSentModerationVacancy';
import ChatModal from '../Chat/ChatModal';
import { useMediaQuery } from '../../utils/useMediaQuery';
import { usePermissions } from '../../hooks/usePermissions';
import { VACANCY_ACTION_PERMISSIONS } from '../../constants/vacancyActionPermissions';

const managerOptions = [
  { value: 'fox', label: 'Fox' },
  { value: 'Butterfly', label: 'Butterfly' },
  { value: 'Honeybee', label: 'Honeybee' },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
export const allInputs = (isHR) => [
  { type: 'text', required: false, label: 'Название организации', name: 'organization_name', isComment: true },
  { type: 'text', required: true, label: 'Название вакансии', name: 'name', isComment: true },
  { type: 'text', required: true, label: 'Адрес', name: 'location', isComment: true },
  {
    type: 'select',
    required: true,
    label: 'Тип вакансии',
    name: 'type',
    list: [
      { value: 'permanent', label: 'Постоянная работа' },
      { value: 'rotational', label: 'Вахта' },
      { value: 'parttime', label: 'Частичная занятость' },
      { value: 'onetime', label: 'Разовая работа' },
    ],
    isComment: true,
  },
  { type: 'textarea', required: true, label: 'Описание вакансии', name: 'description', isComment: true },
  { type: 'textarea', required: false, label: 'Требования к соискателю', name: 'requirements', isComment: true },
  [
    {
      type: 'select',
      required: false,
      label: 'Пол',
      name: 'sex',
      list: [
        { value: '', label: 'Неважно' },
        { value: 'false', label: 'Мужской' },
        { value: 'true', label: 'Женский' },
      ],
    },
    { type: 'text', required: false, label: 'Мин. возраст', name: 'min_age' },
    { type: 'text', required: false, label: 'Макс. возраст', name: 'max_age' },
  ],
  [
    {
      type: 'select',
      required: true,
      label: 'Периодичность выплат',
      name: 'pay_type',
      list: [
        { value: 'everyday', label: 'Ежедневно' },
        { value: 'everyweek', label: 'Еженедельно' },
        { value: 'everymonth', label: 'Ежемесячно' },
      ],
    },
    {
      type: 'text',
      required: true,
      label: 'Мин стоимость раб. смены',
      name: 'min_shift_cost',
    },
    {
      type: 'text',
      required: true,
      label: 'Макс стоимость раб. смены',
      name: 'max_shift_cost',
    },
  ],
  [
    {
      type: 'select',
      required: false,
      label: 'Мин. длит. раб. смены',
      name: 'min_work_duration',
      list: [
        { value: '2', label: '2 часа' },
        { value: '3', label: '3 часа' },
        { value: '4', label: '4 часа' },
        { value: '5', label: '5 часов' },
        { value: '6', label: '6 часов' },
        { value: '7', label: '7 часов' },
        { value: '8', label: '8 часов' },
        { value: '9', label: '9 часов' },
        { value: '10', label: '10 часов' },
        { value: '11', label: '11 часов' },
        { value: '12', label: '12 часов' },
        { value: '13', label: '13 часов' },
        { value: '14', label: '14 часов' },
        { value: '15', label: '15 часов' },
        { value: '16', label: '16 часов' },
        { value: '17', label: '17 часов' },
        { value: '18', label: '18 часов' },
        { value: '19', label: '19 часов' },
        { value: '20', label: '20 часов' },
        { value: '21', label: '21 часов' },
        { value: '22', label: '22 часов' },
        { value: '23', label: '23 часов' },
        { value: '24', label: '24 часов' },
      ],
    },
    {
      type: 'select',
      required: false,
      label: 'Мин. длит. раб. смены',
      name: 'max_work_duration',
      list: [
        { value: '24', label: '24 часов' },
        { value: '23', label: '23 часов' },
        { value: '22', label: '22 часов' },
        { value: '21', label: '21 часов' },
        { value: '20', label: '20 часов' },
        { value: '18', label: '18 часов' },
        { value: '17', label: '17 часов' },
        { value: '16', label: '16 часов' },
        { value: '15', label: '15 часов' },
        { value: '14', label: '14 часов' },
        { value: '13', label: '13 часов' },
        { value: '12', label: '12 часов' },
        { value: '11', label: '11 часов' },
        { value: '10', label: '10 часов' },
        { value: '9', label: '9 часов' },
        { value: '8', label: '8 часов' },
        { value: '7', label: '7 часов' },
        { value: '6', label: '6 часов' },
        { value: '5', label: '5 часов' },
        { value: '4', label: '4 часа' },
        { value: '3', label: '3 часа' },
        { value: '2', label: '2 часа' },
      ],
    },
  ],
  {
    type: 'select',
    required: true,
    label: 'Выбор тарифа',
    name: 'tariff',
    list: isHR
      ? [
          { value: 'hr', label: 'Базовый (1000р.)' },
          { value: 'hr_result', label: 'Базовый + результат (5000р.)' },
          { value: 'hr_guarantee', label: 'Базовый + результат + гарантия (10000р.)' },
        ]
      : [{ label: 'Стартовый (бесплатно)', value: 'onetime' }],
  },
];
export const isBroadcastField = (key) => {
  return ['broadcast_type', 'broadcast_from', 'broadcast_until', 'broadcast_notify'].includes(key);
};

const getHistoryActorName = (actor) => {
  return actor?.full_name ? ` «${actor.full_name}»` : '';
};

const getHistoryActorRole = (actor) => {
  if (actor?.role === 'admin') {
    return 'Администратором';
  }
  if (actor?.role === 'manager') {
    return 'менеджером';
  }
  if (actor?.role === 'employer' || actor?.type === 'employer') {
    return 'контрагентом';
  }
  if (actor?.type === 'staff') {
    return 'сотрудником';
  }
  return 'пользователем';
};

const getVacancyHistoryText = (historyItem) => {
  const actorName = getHistoryActorName(historyItem?.actor);
  const actorRole = getHistoryActorRole(historyItem?.actor);

  switch (historyItem?.type) {
    case 'created':
      return `вакансия создана ${actorRole}${actorName}`;
    case 'edited':
      return `вакансия изменена ${actorRole}${actorName}`;
    case 'broadcast_started':
      return `трансляция вакансии запущена ${actorRole}${actorName}`;
    case 'broadcast_ended':
      return `трансляция вакансии остановлена ${actorRole}${actorName}`;
    case 'deactivated':
      return `вакансия деактивирована ${actorRole}${actorName}`;
    case 'activated':
      return `вакансия активирована ${actorRole}${actorName}`;
    case 'deleted':
      return `вакансия удалена ${actorRole}${actorName}`;
    case 'restored':
      return `вакансия восстановлена ${actorRole}${actorName}`;
    case 'sent_to_moderation':
      return `вакансия отправлена ${actorName} на модерацию`;
    case 'sent_to_employer':
      if (historyItem?.actor?.role === 'admin') {
        return `вакансия отправлена Администратором${actorName} с правками контрагенту`;
      }
      if (historyItem?.actor?.role === 'manager') {
        return `вакансия отправлена менеджером${actorName} с правками контрагенту`;
      }
      return `вакансия отправлена ${actorRole}${actorName} контрагенту`;
    case 'accepted_by_employer':
      return `вакансия согласована контрагентом${actorName}`;
    case 'approved_by_manager':
      return `вакансия согласована ${actorRole}${actorName}`;
    case 'reset':
      return `правки по вакансии отменены ${actorRole}${actorName}`;
    default:
      return historyItem?.description || `зафиксировано действие: ${historyItem?.type}`;
  }
};

function Moderation(props) {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const { hasPermission, hasAnyPermission, hasAllPermissions, isSuperuser } = usePermissions();
  const isMobile = useMediaQuery('(max-width: 700px)');
  const canViewVacancyHistory = hasPermission(VACANCY_ACTION_PERMISSIONS.VIEW_HISTORY);
  const canEditModeration = hasPermission('change_moderation');
  const canSendModeration = isSuperuser || hasPermission('send_moderation');
  const canPostModerationAction = hasPermission('change_vacancy_broadcast');
  const canManageBroadcastSettings = hasAnyPermission(['change_vacancy_full_broadcast', 'change_vacancy_limited_broadcast']);
  const canPostVacancy = canPostModerationAction && canManageBroadcastSettings;
  const canAcceptModerationAction = hasPermission(VACANCY_ACTION_PERMISSIONS.ACCEPT_MODERATION);
  const canViewRegistrationCheckbox = isSuperuser || hasAllPermissions(['view_vacancy', 'change_vacancy_skip_verification']);
  const { pathname } = useLocation();
  const isHR = false;
  const {
    getVacancySingle: { data: getVacancySingleData, error: getVacancySingleError, loading: getVacancySingleLoading },
    skipVerification: { data: skipVerificationData, error: skipVerificationError, loading: skipVerificationLoading },
    updateModerationVacancy: { data: updateModerationVacancyData, error: updateModerationVacancyError, loading: updateModerationVacancyLoading },
    getModerationVacancy: { data: getModerationVacancyData, error: getModerationVacancyError, loading: getModerationVacancyLoading },
    getVacancyHistory: { data: getVacancyHistoryData, loading: getVacancyHistoryLoading },
    sentModerationVacancy: { data: sentModerationVacancyData, error: sentModerationVacancyError, loading: sentModerationVacancyLoading },
    approveModerationVacancy: { data: approveModerationVacancyData, loading: approveModerationVacancyLoading },
    removeModerationVacancy: { data: removeModerationVacancyData, error: removeModerationVacancyError, loading: removeModerationVacancyLoading },
    removeSentModerationVacancy: { data: removeSentModerationVacancyData, error: removeSentModerationVacancyError, loading: removeSentModerationVacancyLoading },
  } = useSelector((state) => state.dashboard);
  const {
    getMe: { data: getMeData },
  } = useSelector((state) => state.user);

  useEffect(() => {
    return () => {
      dispatch(resetRemoveModerationVacancy());
      dispatch(resetRemoveSentModerationVacancy());
    };
  }, [dispatch]);

  useEffect(() => {
    if (updateModerationVacancyData) {
      Swal.fire({
        title: 'Модерация вакансии успешно сохранена',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      setEditState(false);
      dispatch(resetUpdateModerationVacancy());
      dispatch(getModerationVacancy(id));
      refreshVacancyHistory();
    }
  }, [updateModerationVacancyData]);
  useEffect(() => {
    if (sentModerationVacancyData) {
      Swal.fire({
        title: 'Вакансия отправлена контрагенту',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      dispatch(resetSentModerationVacancy());
      dispatch(getModerationVacancy(id));
      refreshVacancyHistory();
    }
  }, [sentModerationVacancyData]);
  useEffect(() => {
    if (approveModerationVacancyData) {
      const isSubordinateApproveCase = getVacancySingleData?.is_subordinate_manager_vacancy === true && getModerationVacancyData?.status === 'approved_by_manager';
      Swal.fire({
        title: isSubordinateApproveCase ? 'Вакансия согласована' : 'Вакансия отправлена на согласование',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      if (isSubordinateApproveCase) {
        setIsSubordinateApproveCompleted(true);
      }
      dispatch(resetApproveModerationVacancy());
      dispatch(getModerationVacancy(id));
      refreshVacancyHistory();
    }
  }, [approveModerationVacancyData]);

  const { id } = useParams();
  useEffect(() => {
    if (id) {
      setIsSubordinateApproveCompleted(false);
      dispatch(getVacancySingle(id));
      dispatch(getModerationVacancy(id));
      refreshVacancyHistory();
    }
  }, [id]);

  const form = useForm();
  const formEdit = useForm();
  const formBroadcast = useForm();
  const moderationPanelVisibleStatuses = ['edited_by_staff', 'sent_to_employer', 'approved_by_manager'];

  useEffect(() => {
    if (!getVacancySingleLoading && !getModerationVacancyLoading && getVacancySingleData) {
      if (getVacancySingleData) {
        form.setValue('organization_name', getVacancySingleData?.employer?.name);
        formEdit.setValue('organization_name', getVacancySingleData?.employer?.name);
        // const vacancyData = getModerationVacancyData?.status == 'accepted_by_employer' ? { ...getVacancySingleData, ...getModerationVacancyData } : getVacancySingleData;
        const vacancyData = getVacancySingleData;

        Object.keys(vacancyData)?.map((key) => {
          const value = key == 'location' ? vacancyData[key]?.address : vacancyData[key];
          if (isBroadcastField(key)) {
            formBroadcast.setValue(key, value);
          } else {
            form.setValue(key, value);
            if (!getModerationVacancyData) {
              formEdit.setValue(key, value);
            }
          }
        });
      }
      if (getModerationVacancyData) {
        formEdit.setValue('can_accept', getModerationVacancyData?.can_accept);
        const { approved_by_admin, approved_by_manager, id, status, comments, ...otherModerationData } = getModerationVacancyData;
        onSetModerationData();
        setFlagModerationVisible(moderationPanelVisibleStatuses.includes(status));
      }
    }
  }, [getVacancySingleData, getModerationVacancyLoading, getVacancySingleLoading, getModerationVacancyData]);
  console.log(form.watch());

  const onSetModerationData = () => {
    const { approved_by_admin, approved_by_manager, id, status, comments, ...otherModerationData } = getModerationVacancyData;
    let moderationComments = {};
    Object.keys(otherModerationData)?.map((key) => {
      const value = key == 'location' ? otherModerationData[key]?.address : otherModerationData[key];
      formEdit.setValue(key, value);
    });
    comments?.map((comment) => {
      moderationComments = { ...moderationComments, [comment.field]: comment.value };
    });
    formEdit.setValue('comments', moderationComments);
  };

  const [item, setItem] = useState([]);

  const [profileModalState, setProfileModalState] = useState(false);
  const [chatModalState, setChatModalState] = useState(false);

  const [editState, setEditState] = useState(false);

  const [historyState, setHistoryState] = useState(false);
  const [managerName, setManagerName] = useState('Ivan');
  const historyRequestedPagesRef = useRef(new Set([1]));
  const [isSubordinateApproveCompleted, setIsSubordinateApproveCompleted] = useState(false);

  useEffect(() => {
    if (!canViewVacancyHistory && historyState) {
      setHistoryState(false);
    }
  }, [canViewVacancyHistory, historyState]);

  function refreshVacancyHistory() {
    if (!id) {
      return;
    }

    historyRequestedPagesRef.current = new Set([1]);
    dispatch(getVacancyHistory({ id, page: 1 }));
  }

  const [flagModerationVisible, setFlagModerationVisible] = useState(false);

  const [sendButtonState, setSendButtonState] = useState(false);
  const [postButtonState, setPostButtonState] = useState(false);
  const [regButtonState, setRegButtonState] = useState(false);
  const [payButtonState, setPayBUttonState] = useState(false);
  const [cancelButtonState, setCancelButtonState] = useState(false);

  const [regCheckState, setRegCheckState] = useState('green');
  const [payCheckState, setPayCheckState] = useState('green');

  const [modalState, setModalState] = useState(false);
  const editInitialValuesRef = useRef(null);

  const normalizeValueForComparison = (value) => {
    if (Array.isArray(value)) {
      return value.map((item) => normalizeValueForComparison(item));
    }

    if (value && typeof value === 'object') {
      return Object.keys(value)
        .sort()
        .reduce((acc, key) => {
          acc[key] = normalizeValueForComparison(value[key]);
          return acc;
        }, {});
    }

    return value ?? null;
  };

  const normalizeFormDataForComparison = (data) => {
    const normalizedData = normalizeValueForComparison(data || {});

    // `comment` is only a transport field for submit payload and should not affect "changed/unchanged" edit detection.
    if (normalizedData && typeof normalizedData === 'object' && Object.prototype.hasOwnProperty.call(normalizedData, 'comment')) {
      delete normalizedData.comment;
    }

    // Empty moderation comments should not be treated as edits.
    if (normalizedData && typeof normalizedData === 'object' && normalizedData.comments && typeof normalizedData.comments === 'object') {
      const filteredComments = Object.entries(normalizedData.comments).reduce((acc, [key, value]) => {
        const normalizedCommentValue = typeof value === 'string' ? value.trim() : value;
        if (normalizedCommentValue) {
          acc[key] = normalizedCommentValue;
        }
        return acc;
      }, {});

      if (Object.keys(filteredComments).length) {
        normalizedData.comments = filteredComments;
      } else {
        delete normalizedData.comments;
      }
    }

    return normalizedData;
  };

  const getChangedFieldPaths = (beforeValue, afterValue, path = '') => {
    const beforeIsObject = beforeValue && typeof beforeValue === 'object';
    const afterIsObject = afterValue && typeof afterValue === 'object';

    const normalizeScalarForComparison = (value) => {
      if (value === null || value === undefined) {
        return '';
      }

      if (typeof value === 'string') {
        return value.trim();
      }

      // Treat equivalent scalar values (`1000` and `"1000"`, `true` and `"true"`) as unchanged.
      if (typeof value === 'number' || typeof value === 'boolean') {
        return String(value);
      }

      return value;
    };

    if (!beforeIsObject || !afterIsObject) {
      return normalizeScalarForComparison(beforeValue) === normalizeScalarForComparison(afterValue) ? [] : [path || 'root'];
    }

    const allKeys = Array.from(new Set([...Object.keys(beforeValue || {}), ...Object.keys(afterValue || {})]));

    return allKeys.flatMap((key) => {
      const nestedPath = path ? `${path}.${key}` : key;
      return getChangedFieldPaths(beforeValue?.[key], afterValue?.[key], nestedPath);
    });
  };

  // const handleProfileModal = () => {
  //     setProfileModalState(!profileModalState)
  // }

  const handleDataFromProfileModal = (data) => {
    setProfileModalState(false);
  };

  const handleDataFromButtonOnProfile = () => {
    setProfileModalState(!profileModalState);
    setChatModalState(!chatModalState);
  };

  const handleChatModal = () => {
    setChatModalState(!chatModalState);
  };

  const handleDataFromChatModal = () => {
    setProfileModalState(!profileModalState);
    setChatModalState(!chatModalState);
  };

  const goProfile = () => {
    navigate('/detail');
  };

  const handleHistoryState = () => {
    if (!canViewVacancyHistory) {
      return;
    }

    setHistoryState(!historyState);
  };

  const handleHistoryScroll = (e) => {
    const nextUrl = getVacancyHistoryData?.next;

    if (getVacancyHistoryLoading || !nextUrl) {
      return;
    }

    const target = e.currentTarget;
    const distanceToBottom = target.scrollHeight - target.scrollTop - target.clientHeight;

    if (distanceToBottom >= 40) {
      return;
    }

    let nextPage = null;
    try {
      nextPage = Number(new URL(nextUrl, window.location.origin).searchParams.get('page'));
    } catch {
      nextPage = Number((nextUrl.match(/[?&]page=(\d+)/) || [])[1]);
    }

    if (!Number.isFinite(nextPage) || nextPage < 1) {
      return;
    }

    if (historyRequestedPagesRef.current.has(nextPage)) {
      return;
    }

    historyRequestedPagesRef.current.add(nextPage);
    dispatch(getVacancyHistory({ id, page: nextPage }));
  };

  const handleDeleteManager = () => {
    setManagerName('');
  };

  const handleChangeManager = (data) => {
    console.log(data.value);
    setManagerName(data.value);
  };

  const handleEditState = () => {
    editInitialValuesRef.current = normalizeFormDataForComparison(formEdit.getValues());
    setEditState(true);
    setFlagModerationVisible(true);
  };

  const handleApprove = () => {
    dispatch(approveModerationVacancy(id));
  };
  const cancelSentEditState = () => {
    Swal.fire({
      title: 'Отменить отправку?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeSentModerationVacancy(id));
      }
    });
  };
  const cancelEditState = () => {
    Swal.fire({
      title: 'Отменить правки?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeModerationVacancy(id));
      }
    });
  };
  const cancelEditSentState = () => {
    Swal.fire({
      title: 'Отменить правки?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeSentModerationVacancy(id));
      }
    });
  };
  // useEffect(() => {
  //   if (removeModerationVacancyData) {
  //     Swal.fire({
  //       title: 'Правки отменены',
  //       showConfirmButton: false,
  //       timer: 1000,
  //       timerProgressBar: true,
  //     });
  //     setEditState(false);
  //     setFlagModerationVisible(false);
  //     dispatch(getModerationVacancy(id));
  //     dispatch(resetRemoveModerationVacancy());
  //   }
  // }, [removeModerationVacancyData]);
  useEffect(() => {
    if (removeSentModerationVacancyData) {
      dispatch(removeModerationVacancy(id));
      dispatch(resetRemoveSentModerationVacancy());
    }
  }, [removeSentModerationVacancyData]);
  useEffect(() => {
    if (removeModerationVacancyData) {
      Swal.fire({
        title: 'Правки отменены',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      setEditState(false);
      setFlagModerationVisible(false);
      dispatch(getModerationVacancy(id));
      refreshVacancyHistory();
      dispatch(resetRemoveModerationVacancy());
    }
  }, [removeModerationVacancyData]);
  const onSave = (data) => {
    const initialData = editInitialValuesRef.current;
    const currentData = normalizeFormDataForComparison(data);
    const changedFields = getChangedFieldPaths(initialData || {}, currentData || {});
    const isFormChanged = changedFields.length > 0;

    console.log(`[Moderation][${id}] Changed fields`, changedFields.length ? changedFields : ['none']);

    if (!isFormChanged) {
      handleCancel();
      return;
    }

    const { comment, comments, ...other } = data;

    const formatComments = Object.keys(comments)
      .map((k) => ({ field: k, value: comments[k] }))
      .filter((item) => item.value);

    dispatch(updateModerationVacancy({ id, comments: formatComments, ...(comment && { comment }), ...other }));
  };
  const handleSaveState = () => {
    setEditState(false);
    // if (item.vacState === 3) {
    //   setSendButtonState(true);
    // }
  };

  const handleCheckState = () => {
    regCheckState === 'green' ? setRegCheckState('orange') : regCheckState === 'orange' ? setRegCheckState('red') : setRegCheckState('green');
  };

  const handlePayCheckState = () => {
    payCheckState === 'green' ? setPayCheckState('red') : setPayCheckState('green');
  };

  const handleCancel = () => {
    setEditState(false);
    if (!moderationPanelVisibleStatuses.includes(getModerationVacancyData?.status)) {
      onSetModerationData();
      setFlagModerationVisible(false);
    }
  };

  const handleClose = () => {
    Swal.fire({
      title: 'Закрыть страницу?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        navigate('/vacancy');
      }
    });
  };

  function handlePost() {
    setModalState(!modalState);
  }

  const formWatch = form.watch();
  const vacancyHistoryList = getVacancyHistoryData?.results || [];
  const employerInfo = [formWatch?.employer?.name, formWatch?.employer?.inn ? `ИНН ${formWatch?.employer?.inn}` : '', formWatch?.employer?.phone]?.filter((item) => item).join(', ');
  const employerEmail = formWatch?.employer?.email;
  const employerLink = formWatch?.employer?.id ? `/user/${formWatch?.employer?.id}` : '';
  const handleSkipVerification = (skip) => {
    Swal.fire({
      title: `Вы действительно хотите ${skip ? 'пропустить' : 'убрать'}  верефикацию этой вакансии ?`,
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          skipVerification({
            id: formWatch.id,
            skip_verification: skip,
          }),
        );
      }
    });
  };
  useEffect(() => {
    if (skipVerificationData) {
      Swal.fire({
        title: skipVerificationData?.skip_verification ? 'Вакансия верефицирована' : 'Верефикация у вакансии сброшена',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      dispatch(resetSkipVerification());
      dispatch(getVacancySingle(id));
      dispatch(getModerationVacancy(id));
      refreshVacancyHistory();
    }
  }, [skipVerificationData]);
  const loading = skipVerificationLoading || updateModerationVacancyLoading || sentModerationVacancyLoading || approveModerationVacancyLoading || removeModerationVacancyLoading;
  const canAccept = formEdit.watch('can_accept');
  const moderationStatus = getModerationVacancyData?.status;
  const comparableModerationFieldNames = allInputs(getVacancySingleData?.is_hr).flatMap((input) => (Array.isArray(input) ? input.map((item) => item.name) : [input.name]));
  const isVacancyAndModerationDataEqualByFields =
    Boolean(getVacancySingleData && getModerationVacancyData) &&
    comparableModerationFieldNames.every((fieldName) => {
      const vacancyFieldValue = normalizeValueForComparison(form.getValues(fieldName));
      const moderationFieldValue = normalizeValueForComparison(formEdit.getValues(fieldName));
      return JSON.stringify(vacancyFieldValue ?? null) === JSON.stringify(moderationFieldValue ?? null);
    });
  const moderationComments = formEdit.getValues('comments');
  const hasModerationComments =
    moderationComments &&
    typeof moderationComments === 'object' &&
    Object.values(moderationComments).some((value) => {
      if (typeof value === 'string') {
        return value.trim().length > 0;
      }
      return Boolean(value);
    });
  const shouldHideModerationPanelBySameDataAndNoComments = isVacancyAndModerationDataEqualByFields && !hasModerationComments;
  const shouldHideModerationPanelOnInitialLoad = !editState && shouldHideModerationPanelBySameDataAndNoComments;
  const shouldShowModerationPanel = flagModerationVisible && !shouldHideModerationPanelOnInitialLoad;
  const currentUserId = getMeData?.id;
  const isAdminOrManager = getMeData?.role === 'admin' || getMeData?.role === 'manager';
  const moderationStatusToHistoryType = {
    edited_by_staff: 'edited',
    reset_by_staff: 'reset',
    sent_to_employer: 'sent_to_employer',
  };
  const latestHistoryType = moderationStatusToHistoryType[moderationStatus] || vacancyHistoryList?.[0]?.type;
  const latestHistoryActorId = getModerationVacancyData?.actor?.id ?? vacancyHistoryList?.[0]?.actor?.id;
  const isLatestHistoryByAnotherUser = latestHistoryActorId != null && currentUserId != null && String(latestHistoryActorId) !== String(currentUserId);
  const isOnlyAcceptWithoutPost = canAcceptModerationAction && !canPostModerationAction;
  const isRestrictedModerationStatus = ['edited_by_staff', 'sent_to_employer', 'reset_by_staff'].includes(moderationStatus);
  const isRestrictedHistoryType = ['edited', 'reset', 'sent_to_employer'].includes(latestHistoryType);
  const hideEditByHistoryRule = isAdminOrManager && canEditModeration && isOnlyAcceptWithoutPost && isRestrictedModerationStatus && isRestrictedHistoryType && isLatestHistoryByAnotherUser;
  const canRenderEditButton = canEditModeration && !hideEditByHistoryRule;
  const isSubordinateManagerVacancy = getVacancySingleData?.is_employer_delegated_to_user === false;
  const canShowAcceptByManagerRule = isSubordinateManagerVacancy ? moderationStatus === 'approved_by_manager' : moderationStatus !== 'approved_by_manager';
  const canShowPostAction = canPostVacancy;
  const canShowAcceptAction = canAcceptModerationAction && canShowAcceptByManagerRule && !isSubordinateApproveCompleted && !canShowPostAction;
  const canShowActionByStatus = moderationStatus !== 'sent_to_employer';
  const canRenderSendButton = ((moderationStatus === 'edited_by_staff' && canSendModeration) || (moderationStatus === 'approved_by_manager' && (isSuperuser || canPostModerationAction))) && !shouldHideModerationPanelBySameDataAndNoComments;
  const canRenderPostButton = canShowPostAction && canShowActionByStatus;
  const canRenderAcceptButton = canShowAcceptAction && canShowActionByStatus && !hideEditByHistoryRule;

  useEffect(() => {
    const postHiddenReasons = [
      !canPostModerationAction && 'Нет права change_vacancy_broadcast (действие Разместить на модерации)',
      !canManageBroadcastSettings && 'Нет права на настройку трансляции (нужен change_vacancy_full_broadcast или change_vacancy_limited_broadcast)',
      !canShowActionByStatus && `Статус ${moderationStatus || 'unknown'}: кнопки скрыты при sent_to_employer`,
    ].filter(Boolean);

    const acceptHiddenReasons = [
      !canAcceptModerationAction && 'Нет права ACCEPT_MODERATION (canAcceptModerationAction=false)',
      !canShowAcceptByManagerRule && (isSubordinateManagerVacancy ? `Для delegated вакансии нужен статус approved_by_manager, сейчас ${moderationStatus || 'unknown'}` : `Для обычной вакансии статус не должен быть approved_by_manager, сейчас ${moderationStatus || 'unknown'}`),
      isSubordinateApproveCompleted && 'Подчиненное согласование уже завершено (isSubordinateApproveCompleted=true)',
      canShowPostAction && 'Кнопка Разместить имеет приоритет, поэтому Согласовать скрыта',
      !canShowActionByStatus && `Статус ${moderationStatus || 'unknown'}: кнопки скрыты при sent_to_employer`,
      hideEditByHistoryRule && 'Последнее действие edited/reset/sent_to_employer сделал другой пользователь: Согласовать скрыта',
    ].filter(Boolean);

    console.groupCollapsed(`[Moderation][${id}] Action buttons debug`);
    console.log('loading flags', {
      skipVerificationLoading,
      updateModerationVacancyLoading,
      sentModerationVacancyLoading,
      approveModerationVacancyLoading,
      removeModerationVacancyLoading,
      loading,
    });
    console.log('requested flags', {
      canAccept,
      moderationStatus,
      currentUserId,
      latestHistoryType,
      latestHistoryActorId,
      isLatestHistoryByAnotherUser,
      isOnlyAcceptWithoutPost,
      hideEditByHistoryRule,
      canRenderEditButton,
      isSubordinateManagerVacancy,
      canShowAcceptByManagerRule,
      canPostModerationAction,
      canManageBroadcastSettings,
      canPostVacancy,
      canAcceptModerationAction,
      isSuperuser,
      isSubordinateApproveCompleted,
      canShowPostAction,
      canShowAcceptAction,
    });
    console.log('button visibility', {
      canShowActionByStatus,
      canRenderPostButton,
      canRenderAcceptButton,
      postHiddenReasons,
      acceptHiddenReasons,
    });
    console.groupEnd();
  }, [
    id,
    skipVerificationLoading,
    updateModerationVacancyLoading,
    sentModerationVacancyLoading,
    approveModerationVacancyLoading,
    removeModerationVacancyLoading,
    loading,
    canAccept,
    moderationStatus,
    currentUserId,
    latestHistoryType,
    latestHistoryActorId,
    isLatestHistoryByAnotherUser,
    isOnlyAcceptWithoutPost,
    hideEditByHistoryRule,
    canRenderEditButton,
    isSubordinateManagerVacancy,
    canShowAcceptByManagerRule,
    canPostModerationAction,
    canManageBroadcastSettings,
    canPostVacancy,
    canAcceptModerationAction,
    isSuperuser,
    isSubordinateApproveCompleted,
    canShowPostAction,
    canShowAcceptAction,
    canShowActionByStatus,
    canRenderPostButton,
    canRenderAcceptButton,
  ]);

  return (
    <div className="mx-auto p-2 flex-1 w-full max-w-[1163px]">
      <div className="w-full mt-9">
        <div className="flex flex-col justify-center items-center px-6 gap-1">
          <p className="text-2xl font-medium">Вакансия {formWatch?.name}</p>
          <input type="text" name="title" disabled={!editState} className="block w-full p-2.5 text-gray-900 text-sm shadow-sm border border-b-1 border-b-gray-500 focus:border-b-blue-700 focus:outline-none " placeholder="Комментарий менеджера" {...formEdit.register('comment', { required: false })} />
        </div>

        <div className="flex flex-col first:flex-row w-full mt-2 gap-2 justify-between">
          {/* <button
                        type='button'
                        className='text-center p-4 w-fit transition ease-in-out duration-300'
                        onClick={handleProfileModal}
                    >
                        ООО "Ромашка", ИНН 9083567289, +7900 9999999, romashka@mail.ru
                    </button> */}

          <div className="flex flex-col sm:flex-row items-start sm:items-center px-4 sm:px-0">
            <p>
              {employerInfo}
              {employerInfo && employerEmail ? ', ' : ''}
              {employerEmail ? (
                employerLink ? (
                  <Link to={employerLink} className="underline">
                    {employerEmail}
                  </Link>
                ) : (
                  employerEmail
                )
              ) : (
                ''
              )}
            </p>
            {/* {item.vacState !== 7 ? (
              <button type="button" className="text-center p-4 w-fit underline transition ease-in-out duration-300" onClick={goProfile}>
                
              </button>
            ) : (
              ''
            )} */}
          </div>

          <div className="flex px-4 sm:px-0 gap-x-2">
            {getVacancySingleData?.is_hr && (
              <ChatModal
                textBtn={'Сообщения'}
                className={'text-center border rounded py-2 px-4  text-button border-button border-1 w-fit hover:text-white bg-white hover:bg-button transition ease-in-out duration-300'}
                vacancyId={getVacancySingleData?.id}
                employerId={getVacancySingleData?.employer?.id}
              />
              // <button type="button" className="text-center border rounded py-2 px-4  text-button border-button border-1 w-fit hover:text-white bg-white hover:bg-button transition ease-in-out duration-300" onClick={handleChatModal}>
              //   Сообщение
              // </button>
            )}

            {canViewVacancyHistory && (
              <button type="button" className="text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov w-fit transition ease-in-out duration-300" onClick={handleHistoryState}>
                История вакансии
              </button>
            )}
          </div>
        </div>

        {!historyState ? (
          <></>
        ) : (
          <div className="flex w-full p-3">
            <div onScroll={handleHistoryScroll} className="flex flex-col w-full mt-2 p-6 gap-y-4 border-1 border-gray-200 rounded-xl shadow-sm h-[254px] overflow-y-auto">
              <div className="w-full">
                {false ? (
                  <div className="flex w-fit py-3">
                    {/* <Select
                      classNames={{
                        menuButton: ({ isDisabled }) =>
                          `flex justify-between pr-1.5 py-1 shadow-sm text-gray-900 text-sm border border-1 border-gray-300 focus:border-button focus:outline-none ${
                            isDisabled
                              ? "bg-gray-200"
                              : "bg-white hover:border-gray-400 focus:border-blue-500 focus:ring focus:ring-blue-500/20"
                          }`,
                        menu: "absolute z-10 w-full bg-white shadow-lg border-1 rounded py-1 mt-1.5 text-sm text-gray-700",
                        listItem: ({ isSelected }) =>
                          `block transition duration-200 px-2 py-2 cursor-pointer select-none truncate rounded ${
                            isSelected
                              ? `text-white bg-blue-500`
                              : `text-gray-500 hover:bg-blue-100 hover:text-blue-500`
                          }`,
                        searchIcon: "hidden ",
                        searchBox:
                          "w-full text-sm text-gray-500 bg-gray-100 border border-gray-200 rounded focus:border-gray-200 focus:ring-0 focus:outline-none",
                      }}
                      placeholder="Менеджер"
                      value={managerName}
                      onChange={handleChangeManager}
                      options={managerOptions}
                      isSearchable
                      isClearable
                    /> */}
                    {managerName !== '' ? (
                      <Menu as="div" className="relative inline-block text-left">
                        <div>
                          <Menu.Button className="inline-flex w-full justify-center border-1 gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900">
                            {managerName}
                            <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" fill="currentColor" className="bi bi-caret-down-fill self-center" viewBox="0 0 16 16">
                              <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"></path>
                            </svg>
                          </Menu.Button>
                        </div>

                        <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                          <Menu.Items className="absolute left-0 z-10 mt-2 w-60 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div className="py-1">
                              <Menu.Item>
                                {({ active }) => (
                                  <Link onClick={handleDeleteManager} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                                    снять менеджера
                                  </Link>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ active }) => (
                                  <Link to={`/editUser`} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                                    профиль менеджера
                                  </Link>
                                )}
                              </Menu.Item>
                            </div>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    ) : (
                      <Select
                        classNames={{
                          menuButton: ({ isDisabled }) => `flex justify-between pr-1.5 py-1 text-gray-900 text-sm ${isDisabled ? 'bg-gray-200' : 'bg-white hover:border-gray-400'}`,
                          menu: 'absolute z-10 w-full bg-white shadow-lg border-1 rounded py-1 mt-1.5 text-sm text-gray-700',
                          listItem: ({ isSelected }) => `block transition duration-200 px-2 py-2 cursor-pointer select-none truncate rounded ${isSelected ? `text-white bg-blue-500` : `text-gray-500 hover:bg-blue-100 hover:text-blue-500`}`,
                          searchIcon: 'hidden ',
                          searchBox: 'w-full text-sm text-gray-500 bg-gray-100 border border-gray-200 rounded focus:border-gray-200 focus:ring-0 focus:outline-none',
                        }}
                        placeholder="manager"
                        value={managerName}
                        onChange={handleChangeManager}
                        options={managerOptions}
                        isSearchable
                      />
                    )}
                  </div>
                ) : (
                  ''
                )}
                <ul className="list-disc px-2 list-outside text-gray-800">
                  {vacancyHistoryList.length ? (
                    <>
                      {vacancyHistoryList.map((historyItem) => (
                        <li key={historyItem.id}>{getVacancyHistoryText(historyItem)}</li>
                      ))}
                      {getVacancyHistoryLoading && (
                        <li className="list-none">
                          <div className="relative h-[44px]">
                            <Loading className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 scale-[0.55]" />
                          </div>
                        </li>
                      )}
                    </>
                  ) : getVacancyHistoryLoading ? (
                    <li className="list-none">
                      <div className="relative h-[80px]">
                        <Loading className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 scale-[0.7]" />
                      </div>
                    </li>
                  ) : (
                    <li>История вакансии пока пуста</li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        )}

        <div className="flex flex-col first:flex-row w-full p-3 mt-4 gap-x-3">
          <div className={`p-6 mt-2 border-1 border-gray-200 rounded-xl shadow-sm transition-all  ${!shouldShowModerationPanel ? 'w-full animate-small-width transition ease-in-out duration-[1200ms]' : 'w-full first:w-1/2 animate-small-width transition ease-in-out duration-[1200ms]'}`}>
            {allInputs(getVacancySingleData?.is_hr)?.map((input) =>
              Array.isArray(input) ? (
                <div
                  className={`w-full mt-6 grid gap-2`}
                  style={{
                    gridTemplateColumns: isMobile ? '1fr' : `repeat(${input?.length},1fr)`,
                  }}>
                  {input?.map((item) => (
                    <Input
                      list={item?.list}
                      type={item.type}
                      {...(!item.required && { rules: { required: false } })}
                      classNameWrap={`mb-6 
                      `}
                      form={form}
                      label={item.label}
                      name={item.name}
                      disabled={true}
                    />
                  ))}
                </div>
              ) : (
                <Input list={input?.list} type={input.type} {...(!input.required && { rules: { required: false } })} classNameWrap={'mt-6'} form={form} label={input.label} name={input.name} disabled={true} />
              ),
            )}
          </div>

          {!shouldShowModerationPanel ? (
            <></>
          ) : (
            <div className={`w-full first:w-1/2 p-6 mt-2 border-1 border-gray-200 rounded-xl shadow-sm animate-wiggle`}>
              {allInputs(getVacancySingleData?.is_hr)?.map((input) =>
                Array.isArray(input) ? (
                  <div
                    className={`w-full mt-6 grid gap-2`}
                    style={{
                      gridTemplateColumns: isMobile ? '1fr' : `repeat(${input?.length},1fr)`,
                    }}>
                    {input?.map((item) => (
                      <Input list={item?.list} type={item.type} {...(!item.required && { rules: { required: false } })} classNameWrap={`mb-6 `} form={formEdit} label={item.label} name={item.name} isComment={item.isComment} disabled={!editState || loading} />
                    ))}
                  </div>
                ) : (
                  <Input
                    list={input?.list}
                    type={input.type}
                    {...(!input.required && { rules: { required: false } })}
                    classNameWrap={'mt-6'}
                    form={formEdit}
                    label={input.label}
                    name={input.name}
                    isComment={input.isComment && input.name != 'organization_name'}
                    disabled={input.name == 'organization_name' || !editState || loading}
                  />
                ),
              )}
            </div>
          )}
        </div>

        <div className="flex gap-2 md:justify-start items-center md:my-10">
          {!editState ? (
            <div className="flex flex-col md:flex-row  gap-2 items-center px-4 md:px-0">
              {canRenderEditButton && (
                <button type="button" className="text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov w-full md:w-fit transition ease-in-out duration-300" onClick={handleEditState}>
                  Редактировать
                </button>
              )}
              {canRenderSendButton ? (
                <button
                  onClick={() => {
                    dispatch(sentModerationVacancy(id));
                  }}
                  type="button"
                  className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-fit hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                  Отправить
                </button>
              ) : (
                ''
              )}
              {canRenderPostButton && (
                <button type="button" onClick={handlePost} className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-fit hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                  Разместить
                </button>
              )}
              {canRenderAcceptButton && (
                <button type="button" onClick={handleApprove} className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-fit hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                  Согласовать
                </button>
              )}

              {canViewRegistrationCheckbox &&
                (formWatch?.employer?.is_verified ? (
                  <Green />
                ) : (
                  <>
                    <Red />
                    {formWatch?.skip_verification ? (
                      <div
                        className="w-[29px] h-[29px] border border-1 border-[#00b2a4] rounded-sm bg-[#00b2a4] flex items-center justify-center cursor-pointer"
                        onClick={() => {
                          if (!skipVerificationLoading) {
                            handleSkipVerification(false);
                          }
                        }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" color="#fff">
                          <path fill="currentColor" d="m9.55 18l-5.7-5.7l1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4z" />
                        </svg>
                      </div>
                    ) : (
                      <div
                        className="w-[29px] h-[29px] border border-1 border-gray-300 rounded-sm bg-gray-200 cursor-pointer"
                        onClick={() => {
                          if (!skipVerificationLoading) {
                            handleSkipVerification(true);
                          }
                        }}></div>
                    )}
                  </>
                ))}

              {/* {regButtonState ? (
                <div className="cursor-pointer" onClick={handleCheckState}>
                  {regCheckState === 'green' ? <Green /> : regCheckState === 'orange' ? <Orange /> : <Red />}
                </div>
              ) : (
                ''
              )} */}
              {payButtonState ? (
                <div className="cursor-pointer" onClick={handlePayCheckState}>
                  {payCheckState === 'green' ? <GreenPay /> : <RedPay />}
                </div>
              ) : (
                ''
              )}
              <button type="button" onClick={handleClose} className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-fit hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                Закрыть
              </button>
            </div>
          ) : (
            <div className="flex flex-col md:flex-row w-full gap-2 items-center px-4 md:px-0">
              <button type="button" className="text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov w-full md:w-fit transition ease-in-out duration-300" onClick={formEdit.handleSubmit(onSave)}>
                Сохранить
              </button>
              {/* {getModerationVacancyData?.status == 'sent_to_employer' && (
                <button type="button" onClick={cancelSentEditState} className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-fit hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                  Отменить отправку
                </button>
              )} */}
              {(getModerationVacancyData?.status == 'edited_by_staff' || getModerationVacancyData?.status == 'sent_to_employer' || getModerationVacancyData?.status == 'approved_by_manager') && (
                <button
                  type="button"
                  onClick={getModerationVacancyData?.status == 'edited_by_staff' || getModerationVacancyData?.status == 'approved_by_manager' ? cancelEditState : getModerationVacancyData?.status == 'sent_to_employer' ? cancelEditSentState : () => {}}
                  className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-fit hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                  Отменить правки
                </button>
              )}

              <button type="button" className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-fit hover:text-white bg-white hover:bg-button transition ease-in-out duration-300" onClick={handleCancel}>
                {getModerationVacancyData?.status == 'edited_by_staff' || getModerationVacancyData?.status == 'sent_to_employer' || getModerationVacancyData?.status == 'approved_by_manager' ? 'Отмена' : ' Отменить правки'}
              </button>
              <input
                type="checkbox"
                checked={canAccept}
                onChange={(e) => {
                  formEdit.setValue('can_accept', e.target.checked);
                }}
                className="w-[16px] h-[16px] rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none"
                {...formEdit.register('can_accept', { required: false })}
              />
            </div>
          )}
          <div class="relative w-[40px]">{loading && <Loading />}</div>
        </div>

        <ProfileModal open={profileModalState} sendDataToParent={handleDataFromProfileModal} sendDataToParentFromButton={handleDataFromButtonOnProfile} />

        <DialogChatModal open={chatModalState} sendDataToParent={handleDataFromChatModal} onCancel={handleChatModal} />

        <BroadCastModal form={formBroadcast} open={modalState} onClose={handlePost} />
      </div>
    </div>
  );
}

export default Moderation;
